import { useNewEditTemplateCollectionContext } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/context/NewEditTemplateCollectionContext"
import { useCallback, useMemo, useState } from "react";
import { collectionAdministrationTableColumns } from "../helpers/columnsCollectionEditTableHelper";
import { useAppSelector } from "@hooks/store";

export const useCollectionEditTable = () => {
    const { currencySymbol } = useAppSelector(state => state.auth)
    const { chargeDebtorsData, cleanTable, setCleanTable, setChargeDebtorsData, setHasUnsavedChanges } = useNewEditTemplateCollectionContext()
    const [currentPage, setCurrentPage] = useState(1)

    const handleSave = useCallback((row) => {
        const newData = [...chargeDebtorsData.dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        newData[index] = {
            ...newData[index],
            ...row,
        };
        setHasUnsavedChanges(true)
        setChargeDebtorsData(prev => ({
            ...prev,
            dataSource: newData,
        }));
    }, [chargeDebtorsData.dataSource, setHasUnsavedChanges, setChargeDebtorsData]);

    const handleRestoreTable = () => {
        setCleanTable(false)
    }

    const handleChangeTale = ({ pagination, filters, sorter, extra }) => {
        setCurrentPage(pagination.current)
    }

    const columns = useMemo(() => collectionAdministrationTableColumns({
        columns: chargeDebtorsData.columns,
        currencySymbol,
        handleSave
    }), [currencySymbol, chargeDebtorsData.columns, handleSave])
    return {
        chargeDebtorsData,
        columns,
        cleanTable,
        currentPage,
        handleChangeTale,
        handleRestoreTable
    }
}